import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["destroy", "positionIndex", "kind", "description"]
  static values = {
    index: { type: Number, default: 0 }
  }

  connect() {
    this.element.addEventListener("additional-descriptions:update-description", this.updateDescription.bind(this))
  }

  delete(event) {
    const confirmed = confirm(event.currentTarget.getAttribute("data-confirm"))
    if (confirmed) {
      this.element.classList.add("hidden")
      this.destroyTarget.checked = true
      this.element.dispatchEvent(new CustomEvent("additional-description:delete", { bubbles: true }))
    }
  }

  updateDescription(event) {
    if (!this.hasPositionIndexTarget || !this.hasKindTarget || !this.hasDescriptionTarget) return

    this.positionIndexTarget.value = event.detail.position_index || ""
    this.kindTarget.value = event.detail.kind || ""
    this.descriptionTarget.value = event.detail.content || ""
  }
}
